
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import buefy from 'buefy';

Vue.use(buefy);

export default Vue.extend({
  data() {
    return {
      usuario: "",
      password: "",
      guardarDatos: false
    };
  },
  mounted() {
    this.usuario = window.localStorage.getItem("usuario") || "";
    this.password = window.localStorage.getItem("password") || "";
    if (this.usuario != "" && this.password != "") {
      this.guardarDatos = true;
    }
  },
  computed: {
    ...mapState(["jwt"])
  },
  methods: {
    ...mapMutations(["anadirStoreAlLocalStorage"]),
    login() {
      const data = {
        contraseña: this.password,
        email: this.usuario
      };

      const loading = this.$loading.open({
        container: null
      });

      this.$http
        .post("Cuentas/Login", data)
        .then(res => {
          if (this.guardarDatos) {
            window.localStorage.setItem("usuario", this.usuario);
            window.localStorage.setItem("password", this.password);
          } else {
            window.localStorage.removeItem("usuario");
            window.localStorage.removeItem("password");
          }

          loading.close();
          this.anadirStoreAlLocalStorage(res.data);
          this.$toast.open({
            message: "Usuario iniciado corretamente!",
            type: "is-success",
            position: "is-bottom"
          });
          this.$router.push("/");

          this.$http
            .get("Registra", {
              headers: {
                Authorization: `Bearer ${this.$store.state.jwt}`
              }
            })
            .then(res => {
              if(res.data.tieneEntrada){
                loading.close();

                this.$toast.open({
                  message: "Tienes una entrada registrada",
                  type: "is-warning",
                  position: "is-bottom"
                });
              }
            });
        })
        .catch(err => {
          loading.close();
          if (err.response.status == 401) {
            this.$toast.open({
              message: "La cuenta no está activada",
              type: "is-danger",
              position: "is-bottom"
            });
          } else {
            this.$toast.open({
              message: "Correo o contraseña incorrecta!",
              type: "is-danger",
              position: "is-bottom"
            });
          }
        });
    }
  }
});
